import { ApolloClient } from '@apollo/client';
import { ValidationError } from 'yup';
import { IOrderRequest } from '../order-request-form';
import { queryOrderRequestProductInput } from '../../../../../../../services';

type CatalogPriceField = 'kilo_price' | 'group_price';

// Factory that builds a yup test asserting the row's price equals the account
// catalog (account_products) price for the selected product. Prices on order
// requests are fixed by the catalog, so any divergence (e.g. a legacy request
// whose stored price predates a catalog change) is surfaced under the field.
// The catalog query is cache-first, so it reuses the data the product picker
// already fetched for the account instead of hitting the network again.
export function makeDoesPriceMatchCatalog(
    apolloClient: ApolloClient<object>,
    field: CatalogPriceField,
) {
    return async function (
        value: any,
        context: any,
    ): Promise<boolean | ValidationError> {
        const { product } = context.from[0]
            .value as IOrderRequest['order_request_products'][number];
        const { account_id } = context.from[1].value as IOrderRequest;

        if (!product || !account_id) return true;

        const result = await queryOrderRequestProductInput(apolloClient, {
            accountId: account_id,
        });

        const catalogProduct = (result.data.getAccountProducts || []).find(
            (accountProduct) => accountProduct.product?.id === product.id,
        );

        // Membership is enforced by the product picker and the backend; only
        // flag a price mismatch when the product actually has a catalog row.
        if (!catalogProduct) return true;

        const catalogPrice =
            field === 'kilo_price'
                ? Number(catalogProduct.kilo_price)
                : Number(catalogProduct.group_price);

        if (Number(value) !== catalogPrice) {
            return context.createError({
                message: `El precio no coincide con el catálogo del cliente (${catalogPrice})`,
            });
        }

        return true;
    };
}
